<template>
  <div>
    <canvas ref="gaugeCanvas" width="485" height="260" />
  </div>
</template>
<script>
import gimage from "../../static/gauge.png";
const gearScores = [0, 60, 70, 80, 100];

export default {
  name: "Gauge",
  props: ["chartData", "programme"], // eslint-disable-line vue/require-prop-types
  methods: {
    showImage() {
      const score = this.chartData;
      let canvas = this.$refs.gaugeCanvas;
      let ctx = canvas.getContext("2d");
      let gi = new Image();
      gi.src = gimage;

      // white background for right-hand-click-save
      ctx.style = {};
      ctx.style.backgroundColor = "rgba(255,0,0,255)";

      // canvas values
      const cw = canvas.offsetWidth;
      const ch = canvas.offsetHeight;
      const cx = cw / 2;
      const cy = ch - 15;

      gi.onload = function() {
        ctx.drawImage(gi, 0, 0);
        const degrees = gearScores.reduce((accumulator, value, index) => {
          if (!accumulator && score < value) {
            const bandWidth = value - gearScores[index - 1];
            const base10Value =
              (25 * (score - gearScores[index - 1])) / bandWidth +
              (index - 1) * 25;
            // in 180 degrees
            return (base10Value / 100) * 180;
          }
          return accumulator;
        }, null);

        const radians1 = (degrees * Math.PI) / 180;
        const radians2 = ((degrees - 181) * Math.PI) / 180;
        const radians3 = ((degrees - 90) * Math.PI) / 180;
        const radius = 12;
        ctx.beginPath();
        ctx.moveTo(
          cw / 2 + radius * Math.sin(radians1),
          ch - radius - radius * Math.cos(radians1)
        );
        ctx.lineTo(
          cw / 2 + (ch / 1.75) * Math.sin(radians3),
          ch - radius - (ch / 1.75) * Math.cos(radians3)
        );
        ctx.lineTo(
          cw / 2 + radius * Math.sin(radians2),
          ch - radius - radius * Math.cos(radians2)
        );
        ctx.fillStyle = "#000000";
        ctx.fill();
      };
    }
  },

  mounted: function() {
    this.showImage();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Gauge.vue